import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { dataFetcher, endpoints, baseUrl, cloudBaseUrl } from 'Api';
import axios from 'axios';
import { Skeleton } from '@mui/material';
import { AppContext, AuthContext } from 'Context';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from 'Components';
import CustomButton from 'Components/button/CustomButton';
import CreateCategoryPage from '../../content-layout/CreateCategory';
import Logo from '../../../../Assets/published.png';
import { StoragePage } from '../components/page';
import { videoArray } from './DataArray';
import { photoArray } from './PhotoArray';
import Publish from '../PublishUi/Publish';
import Sort from '../../../../Assets/sort.png';
import Shimmer from '../Shimmer';
import styles from './index.module.css';
import EditPublish from '../PublishUi/EditPublish';

export const CategoryCloud = () => {
  const {
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    storageSelectedItems,
    setStorageSelectedItems,
    setOpenX,
    cloudToken,
    setAppSnackbar,
    categoryDetails,
    userDetails,
  } = useContext(AppContext);
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const location = useLocation();

  const [data, setData] = useState({ results: [], next: null });
  const [loading, setLoading] = useState(false);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [page, setPage] = useState(1);
  const containerRef = useRef(null);
  const profileID = userDetails.myId;
  const { category } = useParams();
  const { getToken } = useContext(AuthContext);
  const [thumbnailSelected, setThumbnailSelected] = useState();
  const [subCategories, setSubCategories] = useState([]);
  const [addToProjector, setAddToProjector] = useState(false);
  const [detailsData, setDetailsData] = useState({
    title: '',
    duration: undefined,
    height: undefined,
    width: undefined,
    description: '',
    categrory: undefined,
    visibility: 2,
    group: [], // ✅ Must be an array!
  });
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / 1024 ** i).toFixed(2)} ${sizes[i]}`;
  };
  const groupByDate = (files) => {
    if (!Array.isArray(files)) return {};
    return files.reduce((acc, file) => {
      const dateObj = new Date(file.uploaded_at);
      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(file);
      return acc;
    }, {});
  };
  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const groupedFiles = groupByDate(data?.results);
  const handleSelect = (item) => {
    const isAlreadySelected = storageSelectedItems.some(
      (selected) => selected.id === item.id
    ); // assuming `id` is unique
    if (isAlreadySelected) {
      setStorageSelectedItems(
        storageSelectedItems.filter((selected) => selected.id !== item.id)
      );
    } else {
      setStorageSelectedItems([...storageSelectedItems, item]);
    }
  };

  const { isValidating: isCategoryLoading, mutate: getCategoryDetails } = useSWR([endpoints.getCategoryDetail, profileID, category], {
      fetcher: (url, user_id, category_id) => dataFetcher(url, { user_id, category_id }),
      onSuccess: ({ success, videos, message, details }) => {
        if (success) {
          setSubCategories([{ title: details?.title, videos }]);
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: message || 'Oops! Something went wrong',
          });
        }
        setLoading(false); // Set loader to false when data has been successfully fetched or when an error occurs
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: responseData?.message || 'Oops! Something went wrong',
        });
        setLoading(false); // Ensure loader is set to false on error as well
      },
    });
  useEffect(() => {
    setLoading(true); // Set loader to true when starting to fetch data
    getCategoryDetails();
  }, [categoryDetails, category]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (
        !loading
        && data.next
        && !loadingNextPage
        && scrollTop + clientHeight + 100 >= scrollHeight
      ) {
        const nextPage = page + 1;
        // fetchData(nextPage);
      }
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [loading, data.next, page, loadingNextPage]);
  async function urlToFile(url, filename) {
    const response = await fetch(url);
    const blob = await response.blob();
    const fileType = blob.type || 'image/jpeg'; // fallback
    return new File([blob], filename, { type: fileType });
  }
  async function appendThumbnails(formData, storageSelectedItems) {
    const preThumbnails = storageSelectedItems?.[0]?.pre_thumbnails;
    if (!Array.isArray(preThumbnails) || preThumbnails.length === 0) {
      console.warn('No thumbnails found.');
      return;
    }
    // eslint-disable-next-line
    for (let index = 0; index < preThumbnails.length; index++) {
      const url = preThumbnails[index];
      try {
        // eslint-disable-next-line
        const file = await urlToFile(url, `thumbnail_${index}.jpg`);
        console.log('thumbnails[]', file);
        formData.append('thumbnails[]', file);
      } catch (err) {
        console.error(`Error processing thumbnail ${index}:`, err);
      }
    }
  }
  const [deleteLoading, setDeleteLoading] = useState(false);
  const deleteFiles = async () => {
    setDeleteLoading(true);
  const payload = {
  ids: [], // e.g. [1473, 1466, 1460]
  stream_ids: storageSelectedItems?.map((item) => item?.draft_id),
  streamToken: getToken(),
    };
    console.log('Payload before request:', payload);
  try {
    const response = await axios.post(
      `${cloudBaseUrl}/documents/delete-files/`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cloudToken?.access}`,
        }
      }
    );
      setStorageSelectedItems([]);
    setDeleteLoading(false);
    getCategoryDetails();

    console.log('Delete Success:', response.data);
  } catch (error) {
 setDeleteLoading(false);
    console.error('Delete Failed:', error.response?.data || error.message);
  }
};
  const convertAllUrlsToFiles = async (urls) => {
    const files = await Promise.all(
      urls.map((url, index) => urlToFile(url, `thumbnail_${index}.png`))
    );

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('thumbnails[]', file);
    });

    return formData;
  };
  useEffect(() => {
    // Clear selected items when route changes
    setStorageSelectedItems([]);
  }, [location.pathname]); // triggered every time the path changes

  async function shareAndStreme(theGreatPayload) {
    const apiUrl = `${baseUrl}/V6/addVideoContnet`;
    try {
      const response = await axios.post(apiUrl, theGreatPayload);
      setStorageSelectedItems([]);
      setAddToProjector(false);
    } catch (error) {
      console.error('Error sending video data:', error);
    }
  }
  const sendDataToServer = async () => {
    const formData = new FormData();
    formData.append('token', getToken());
    formData.append('title', detailsData?.title);
    formData.append('description', detailsData?.description);
    formData.append('category_id', detailsData?.categrory);
    formData.append('visibility', detailsData?.visibility);
    formData.append('group_ids', detailsData?.group);
    formData.append('video_id', storageSelectedItems[0]?.id);
    formData.append('draft_id', storageSelectedItems[0]?.draft_id);
    formData.append('thumbnail_list', storageSelectedItems[0]?.thumbnails); // if empty or a stringified array
    formData.append('playlist_id', storageSelectedItems[0]?.playlist_id);
    formData.append('subcategory_id', storageSelectedItems[0]?.subcategory_id);
    formData.append('thumbnails', storageSelectedItems[0]?.thumbnails); // leave empty or append a File object if available
    formData.append('status', storageSelectedItems[0]?.status);
    shareAndStreme(formData);
  };
  const publishHandler = () => {
    if (addToProjector) {
      sendDataToServer();
      return;
    }
    if (storageSelectedItems?.length === 1) {
      setDetailsData({
        title: storageSelectedItems[0]?.title ?? '',
        duration: undefined,
        height: undefined,
        width: undefined,
        description: storageSelectedItems[0]?.description ?? '',
        categrory: storageSelectedItems[0]?.category_id ?? undefined,
        thumbnail: storageSelectedItems[0]?.draft_thumbnails ?? '',
        visibility: Number(storageSelectedItems[0]?.visibility ?? 2),
        group: [], // Keep default unless populated
      });
      setAddToProjector(true);
    } else {
      setOpenX(true);
    }
  };

  return (
    <StoragePage
      title={
        !loading && subCategories[0]?.videos?.length > 0
          ? `${subCategories[0]?.videos?.length} videos on ${subCategories[0]?.title}`
          : categoryDetails?.name
      }
      // addActionName={viewerText?.addViewer || 'Add viewer'}
      // addActionName={'Add viewer'}
      // link={Pathname.grantAccess}
    >
      <div className={styles.viewersDiv}>
        <div className={styles.aboveGrid}>
          <div className={styles.topix}>
            <div className={styles.allViewersContainer} ref={containerRef}>
              {loading ? (
                <div className={styles.shimmer}>
                  <Shimmer type="categoryvideo" />
                </div>
              ) : subCategories[0]?.videos?.length > 0 ? (
                subCategories[0]?.videos?.map((item, index) => (
                  <div>
                    <div
                      className={styles.gridImg}
                      key={item?.id}
                      role="button"
                      tabIndex={0}
                      onClick={() => handleSelect(item)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSelect(item);
                        }
                      }}
                    >
                      <Checkbox
                        checked={storageSelectedItems?.some(
                          (selected) => selected.id === item.id
                        )}
                        icon={<></>} // ✅ safely renders nothing
                        checkedIcon={<CheckCircleIcon />} // ✅ shown only when selected
                        sx={{
                          color: '#e6dfda',
                          '&.Mui-checked': {
                            color: '#e6dfda',
                          },
                        }}
                        style={{
                          position: 'absolute',
                          top: '40%',
                          left: '42%',
                          zIndex: 2,
                          borderRadius: 4,
                          padding: 0,
                          pointerEvents: 'none', // allow click-through
                        }}
                      />
                      <img
                        src={item?.imagekit_icon}
                        className={styles.eachThum}
                        alt={item?.name}
                      />
                      {item?.draft_id !== null && (
                        <img
                          className={styles.isStream}
                          src={Logo}
                          alt={item?.name}
                        />
                      )}
                    </div>
                    <span className={styles.videoTtile}>{item?.title}</span>
                  </div>
                ))
              ) : (
                <div className={styles.noData}>No data found</div>
              )}
              {loadingNextPage
                && Array.from({ length: 16 }).map((_, index) => (
                  <div
                    className={styles.gridItemX}
                    key={index + data.results.length}
                  >
                    <Skeleton
                      variant="rectangular"
                      height={130}
                      width={100}
                      animation="wave"
                      sx={{
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {storageSelectedItems?.length > 0 && (
          <div className={styles.pendingViewersContainer}>
            <EditPublish
              type="video"
              addToProjector={addToProjector}
              setSelectedCheckedItems={setStorageSelectedItems}
              selectedCheckedItems={storageSelectedItems}
              formatFileSize={formatFileSize}
              handleDetailsChange={handleDetailsChange}
              detailsData={detailsData}
              setDetailsData={setDetailsData}
              thumbnailSelected={thumbnailSelected}
              setThumbnailSelected={setThumbnailSelected}
            />

            <div className={styles.buttonsfleximo}>
        <CustomButton onClick={deleteFiles} loading={deleteLoading} border="red" name="Delete" />
              {storageSelectedItems?.length === 1 && (
                <CustomButton
                  disabled={storageSelectedItems?.length < 1}
                  onClick={publishHandler}
                  border="#5AA5EF"
                  name="Update Video"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </StoragePage>
  );
};
